import React from "react";
import { tierOption } from "../tierMeta";

interface Props {
  tier?: string;
  className?: string;
}

export default function TierBadge({ tier, className = "" }: Props) {
  const option = tierOption(tier);
  if (!option) return null;

  return (
    <span className={`v2-tier-chip v2-tier-chip--${option.value} ${className}`}>
      <img src={option.icon} alt="" aria-hidden="true" />
      {option.tier}
    </span>
  );
}
